export const NOTIFY_TOAST_HIDE_DELAY = 3000;
export const INFO_TOOLTIP_HIDE_DELAY = 1500;
